import { render, staticRenderFns } from "./showDataAccessHeader.vue?vue&type=template&id=0e72da0a&scoped=true&"
import script from "./showDataAccessHeader.vue?vue&type=script&lang=js&"
export * from "./showDataAccessHeader.vue?vue&type=script&lang=js&"
import style0 from "./showDataAccessHeader.vue?vue&type=style&index=0&id=0e72da0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e72da0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
